module.exports = __webpack_public_path__ + "static/media/styledDatepicker-Chevrom-Right.96b9bee3.svg";